import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import './chartSetup';
import { CHART_COLORS, defaultChartOptions } from './chartSetup';

const FUNNEL_COLORS = [CHART_COLORS.yellow, CHART_COLORS.cyan, CHART_COLORS.pink, CHART_COLORS.green];

const HorizontalFunnelChart = ({ stages = [], title = 'Learning Funnel' }) => {
  const chartData = useMemo(() => ({
    labels: stages.map((stage) => stage.stage),
    datasets: [{
      label: 'Conversion',
      data: stages.map((stage) => stage.percent),
      backgroundColor: stages.map((_, index) => FUNNEL_COLORS[index % FUNNEL_COLORS.length]),
      borderRadius: 6,
      barThickness: 28
    }]
  }), [stages]);

  const options = useMemo(() => ({
    ...defaultChartOptions,
    indexAxis: 'y',
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        grid: { color: '#f3f4f6' },
        ticks: {
          color: '#6b7280',
          callback: (tickValue) => `${tickValue}%`
        }
      },
      y: {
        grid: { display: false },
        ticks: { color: '#374151', font: { weight: '600' } }
      }
    },
    plugins: {
      ...defaultChartOptions.plugins,
      legend: { display: false },
      tooltip: {
        ...defaultChartOptions.plugins.tooltip,
        callbacks: {
          label: (context) => {
            const stage = stages[context.dataIndex];
            return `${stage.percent}% (${stage.count.toLocaleString()})`;
          }
        }
      }
    }
  }), [stages]);

  if (!stages.length) {
    return (
      <div className="h-56 flex items-center justify-center text-sm text-gray-500">
        No funnel data available
      </div>
    );
  }

  return (
    <div>
      <h3 className="text-base font-bold text-gray-900 mb-4">{title}</h3>
      <div className="h-56" role="img" aria-label={`${title} chart`}>
        <Bar data={chartData} options={options} />
      </div>
      <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-2">
        {stages.map((stage, index) => (
          <div key={stage.stage} className="text-center">
            <div
              className="w-3 h-3 rounded-full mx-auto mb-1"
              style={{ backgroundColor: FUNNEL_COLORS[index % FUNNEL_COLORS.length] }}
            />
            <p className="text-xs text-gray-500">{stage.stage}</p>
            <p className="text-sm font-bold text-gray-800">{stage.percent}%</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HorizontalFunnelChart;
